import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import InfoUserApi from '../api/user/info_user.ts';

export const fetchUserAsync = createAsyncThunk(
    'user/fetchUser',
    async () => {
        const response = await InfoUserApi();
        return response;
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState: {
        data: [""],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUserAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchUserAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchUserAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default userSlice.reducer;